const ValidSelectionKeys = ['Enter', ' '];

export const buildKeyboardEventHandler =
  (onClickHandler: () => void) =>
  (keyboardEvent: React.KeyboardEvent): void => {
    if (ValidSelectionKeys.includes(keyboardEvent.key)) {
      onClickHandler();
    }
  };
